<div class="sip-switch">
  <div class="toggle-btn">
    <span [class.active]="!payment_config?.is_sip">Give Once</span><mat-slide-toggle (change)="sipToggle($event.checked)" [checked]="payment_config?.is_sip"></mat-slide-toggle> <span [class.active]="payment_config?.is_sip">Give Monthly</span>
  </div>
  <div class="desc" *ngIf="!payment_config?.is_sip">Help us support hundreds of families this week.</div>
  <div class="desc" *ngIf="payment_config?.is_sip">Help us support hundreds of lives every month.</div>
</div>